<template>
    <div class="FosterFamilyInquiryForm">
        <div class="container">
            <div class="row">
                <div class="col paper center-text">
                    <img :src="HeaderImg" style="width: 100%; max-width: 491px;"/>
                    <h2 style="margin-top:25px;">Foster Family Inquiry</h2>
                    <p v-if="PagePhase == 'Form'">Please fill out your information below and one of our Family Specialists will get in contact with you!</p>
                </div>
            </div>
            <div v-if="PagePhase == 'Form'">
                <b-form @submit="SubmitForm">
                    <div class="row">
                        <div class="col-lg paper">
                            <h4>Your Name(s)</h4>
                            <p class="center-text">Parent 1</p>
                            <div class="form-group">
                                <label>First Name:</label>
                                <input type="text" class="form-control" required v-model="FamilyInfo.Parent1FirstName" />
                            </div>
                            <div class="form-group">
                                <label>Last Name:</label>
                                <input type="text" class="form-control" required v-model="FamilyInfo.Parent1LastName" />
                            </div>
                            <p class="center-text">Parent 2 (if applicable)</p>
                            <div class="form-group">
                                <label>First Name:</label>
                                <input type="text" class="form-control" v-model="FamilyInfo.Parent2FirstName" />
                            </div>
                            <div class="form-group">
                                <label>Last Name:</label>
                                <input type="text" class="form-control" v-model="FamilyInfo.Parent2LastName" />
                            </div>
                        </div>
                        <div class="col-lg paper">
                            <h4>Contact Info</h4>
                            <div class="form-group">
                                <label>Email:</label>
                                <input type="email" class="form-control" required v-model="FamilyInfo.Email" />
                            </div>
                            <div class="form-group">
                                <label>Phone Number:</label>
                                <input type="tel" class="form-control" required v-model="FamilyInfo.Phone" />
                            </div>
                            <div class="form-group">
                                <label>Address:</label>
                                <input type="text" v-model="FamilyInfo.AddressLine1" class="form-control" required placeholder="Address Line 1" />
                                <input type="text" v-model="FamilyInfo.AddressLine2" class="form-control" placeholder="Address Line 2 (optional)" />
                                <input type="text" v-model="FamilyInfo.City" required class="form-control" placeholder="City" />
                                <b-row>
                                    <div class="col-6 no-padding">
                                        <select class="form-control" required v-model="FamilyInfo.StateAbbreviation">
                                            <option v-for="option in StateOptions" :value="option.value">
                                                {{option.text}}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-6 no-padding">
                                        <input type="text" v-model="FamilyInfo.ZipCode" class="form-control" required placeholder="Zip" />
                                    </div>
                            </div>
                        </div>
                        <div class="col-lg paper">
                            <h4>Other Info</h4>
                            <div class="form-group">
                                <label>How did you hear about Olive Crest?</label>
                                <select v-model="FamilyInfo.ReferralSource" class="form-control">
                                    <option value="Church">Church</option>
                                    <option value="Olive Crest Family">Olive Crest Family</option>
                                    <option value="Olive Crest Employee">Olive Crest Employee</option>
                                    <option value="A Friend">A Friend</option>
                                    <option value="Internet Search">Internet Search</option>
                                    <option value="County Agency">County Agency</option>
                                    <option value="Send Conference">Send Conference</option>
                                    <option value="Other">Other (Describe Below)</option>
                                </select>
                                <!--<b-form-radio v-model="FamilyInfo.ReferralSource" size="lg" name="FamilyInfo.ReferralSource" value="Church">Church</b-form-radio>
                                <b-form-radio v-model="FamilyInfo.ReferralSource" size="lg" name="FamilyInfo.ReferralSource" value="Olive Crest Family">Olive Crest Family</b-form-radio>
                                <b-form-radio v-model="FamilyInfo.ReferralSource" size="lg" name="FamilyInfo.ReferralSource" value="Olive Crest Employee">Olive Crest Employee</b-form-radio>
                                <b-form-radio v-model="FamilyInfo.ReferralSource" size="lg" name="FamilyInfo.ReferralSource" value="A Friend">A Friend</b-form-radio>
                                <b-form-radio v-model="FamilyInfo.ReferralSource" size="lg" name="FamilyInfo.ReferralSource" value="Internet Search">Internet Search</b-form-radio>
                                <b-form-radio v-model="FamilyInfo.ReferralSource" size="lg" name="FamilyInfo.ReferralSource" value="County Agency">County Agency</b-form-radio>
                                <b-form-radio v-model="FamilyInfo.ReferralSource" size="lg" name="FamilyInfo.ReferralSource" value="Other">Other</b-form-radio>-->
                                <input v-if="FamilyInfo.ReferralSource == 'Church'" placeholder="Name of Church" type="text" class="form-control" v-model="FamilyInfo.ChurchName" required />
                                <textarea v-if="FamilyInfo.ReferralSource == 'Other'" rows="5" class="form-control" placeholder="Describe" v-model="FamilyInfo.ReferralSourceComments" />
                            </div>
                            <div class="form-group">
                                <label>Best Time to Reach {{ PluralChangerUsMe }}:</label>
                                <div class="availability-checkboxes">
                                    <b-form-checkbox-group v-model="FamilyInfo.Availability" stacked>
                                        <b-form-checkbox value="Mondays">Mondays</b-form-checkbox>
                                        <b-form-checkbox value="Tuesdays">Tuesdays</b-form-checkbox>
                                        <b-form-checkbox value="Wednesdays">Wednesdays</b-form-checkbox>
                                        <b-form-checkbox value="Thursdays">Thursdays</b-form-checkbox>
                                        <b-form-checkbox value="Fridays">Fridays</b-form-checkbox>
                                        <b-form-checkbox value="Mornings">Mornings</b-form-checkbox>
                                        <b-form-checkbox value="Afternoons">Afternoons</b-form-checkbox>
                                    </b-form-checkbox-group>
                                </div>
                            </div>
                            <div class="form-group">
                                <label>{{ PluralChangerWeAreIAm }}...</label>
                                <select v-model="FamilyInfo.Sureness" class="form-control">
                                    <option value="Ready to say YES! to our calling">Ready to say "Yes!" to our calling</option>
                                    <option value="Seeking general information about Olive Crest's foster care and adoptions services">Seeking general information about Olive Crest's foster care and adoptions services</option>
                                    <option value="Still figuring things out">Still figuring things out</option>
                                </select>
                                <!--<b-form-radio v-model="FamilyInfo.Sureness" size="lg" name="FamilyInfo.Sureness" value="Ready to say YES! to our calling">Ready to say "Yes!" to our calling</b-form-radio>
                                <b-form-radio v-model="FamilyInfo.Sureness" size="lg" name="FamilyInfo.Sureness" value="Seeking general information about Olive Crest's foster care and adoptions services">Seeking general information about Olive Crest's Foster care and adoptions services</b-form-radio>
                                <b-form-radio v-model="FamilyInfo.Sureness" size="lg" name="FamilyInfo.Sureness" value="Still figuring things out">Still figuring things out</b-form-radio>-->
                            </div>
                            <div class="form-group">
                                <label>{{ PluralChangerWeAreIAm }} considering Olive Crest because...</label>
                                <select v-model="FamilyInfo.ConsideringBecause" class="form-control">
                                    <option value="of your reputation for support">of your reputation for support</option>
                                    <option value="of your faith foundation on Judeo-Christian Values">of your faith foundation on Judeo-Christian Values</option>
                                    <option value="we are called to care for vulnerable children">{{PluralChangerWeAreIAmLower}} called to care for vulnerable children</option>
                                    <option value="we know other families who have benefitted from your support">{{PluralChangerWeILower}} know other families who have benefitted from your support</option>
                                    <option value="Other">Other (Describe Below)</option>
                                </select>
                                <!--<b-form-radio v-model="FamilyInfo.ConsideringBecause" size="lg" name="FamilyInfo.ConsideringBecause" value="of your reputation for support">of your reputation for support</b-form-radio>
                                <b-form-radio v-model="FamilyInfo.ConsideringBecause" size="lg" name="FamilyInfo.ConsideringBecause" value="of your faith foundation on Judeo-Christian Values">of your faith foundation on Judeo-Christian Values</b-form-radio>
                                <b-form-radio v-model="FamilyInfo.ConsideringBecause" size="lg" name="FamilyInfo.ConsideringBecause" value="we are called to care for vulnerable children">{{PluralChangerWeAreIAmLower}} are called to care for vulnerable children</b-form-radio>
                                <b-form-radio v-model="FamilyInfo.ConsideringBecause" size="lg" name="FamilyInfo.ConsideringBecause" value="we know other families who have benefitted from your support">{{PluralChangerWeILower}} know other families who have benefitted from your support</b-form-radio>
                                <b-form-radio v-model="FamilyInfo.ConsideringBecause" size="lg" name="FamilyInfo.ConsideringBecause" value="Other">Other</b-form-radio>-->
                                <textarea v-if="FamilyInfo.ConsideringBecause == 'Other'" rows="5" class="form-control" placeholder="Describe" v-model="FamilyInfo.ConsideringBecauseComments" />
                            </div>
                            <div class="form-group">
                                <label>What Community do you live in?</label>
                                <select class="form-control" v-model="FamilyInfo.Region" required :disabled="RegionParam">
                                    <optgroup label="California" v-if="!StateParam || StateParam == 'California'">
                                        <option value="20827676-A48A-44C3-A4FE-262B9A9590E3">Orange County</option>
                                        <option value="2BA75DD8-FF5F-4618-83AA-424791BDABF0">Los Angeles</option>
                                        <option value="CBA01001-B337-425E-BA38-9043F640CF2F">Inland or Desert Communities</option>
                                        <option value="66C9F02F-23AA-4E15-B6A6-F6782FC8F2BB">San Diego</option>
                                    </optgroup>
                                    <optgroup label="Washington State" v-if="!StateParam || StateParam == 'Washington'">
                                        <option value="E93C7592-EEAD-4921-85AB-3D978BC98CEB">Bellevue</option>
                                        <option value="36F4A54E-89A7-457B-96CC-105B6038B351">Silverdale</option>
                                        <option value="1FCD0794-F57A-4413-B7A8-8E3BC670EADE">Tacoma</option>
                                    </optgroup>
                                    <optgroup label="Nevada" v-if="!StateParam || StateParam == 'Nevada'">
                                        <option value="9EE9C71D-89D1-409F-BCA6-428A22738BAC">Las Vegas</option>
                                    </optgroup>
                                    <optgroup label="California" v-if="!StateParam || StateParam == 'Send'">
                                        <option value="20827676-A48A-44C3-A4FE-262B9A9590E3">Other</option>
                                    </optgroup>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <button type="submit" class="btn btn-success form-control" style="margin-bottom:25px;">SUBMIT</button>
                        </div>
                    </div>
                </b-form>
            </div>
            <div v-if="PagePhase == 'Confirmation'">
                <div class="row">
                    <div class="col paper">
                        <h4 class="center-text">Information Submitted</h4>
                        <p>Dear Friend,</p>
                        <p>Thank you for taking the time to request an introduction to Olive Crest. Olive Crest transforms the lives of children in crisis through the healing power of God, family, and community. We are happy you are exploring your calling with us. We are confident we can support you in serving children and families in crises.</p>
                        <p>Within the next 24-48 hours you can expect to receive a message* from an Olive Crest Family Specialist.  Your Family Specialist will schedule a time to chat with you on the phone. We look forward to getting to know you better, and hearing what is calling you to serve children and families.</p>
                        <p>Thank you again for considering Olive Crest.  We hope you are blessed by your experience.</p>
                        <p>If you have not heard from us within 48 hours please reach out to us at 866.461.2445</p>
                        <p> </p>
                        <p>*On occasion, an email from Olive Crest may land in your spam folder.</p>
                        <p>Click <a href="https://www.olivecrest.org/what-we-do-strong-families">HERE</a> to return to the Olive Crest home page.</p>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
    //import components
    
    export default {
        props: [
            
        ],
        data: function () {
            return {
                FamilyInfo: {
                    Parent1FirstName: "",
                    Parent1LastName: "",
                    Parent2FirstName: "",
                    Parent2LastName: "",
                    Email: "",
                    Phone: "",
                    AddressLine1: "",
                    AddressLine2: "",
                    City: "",
                    StateAbbreviation: "",
                    ZipCode: "",
                    Availability: [],
                    ReferralSource: "",
                    Region: ""
                },
                HeaderImg: "/images/Olive-Crest-Logo.png",
                PagePhase: "Form",//Form, Confirmation
            };
        },
        methods: {
            SubmitForm(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("POST", "Foster/FosterInquiry/RecordInquiry", this.FamilyInfo, this.SubmitFormSuccess, () => { }, true);
            },
            SubmitFormSuccess(response) {
                this.PagePhase = "Confirmation";
            }
        },
        components: {
        },
        mounted() { 
            if (this.RegionParam) {
                this.FamilyInfo.Region = this.RegionParam;
            }
        },
        computed: {
            StateOptions: function () {
                return this.$store.state.Options.USStateAbbreviations;
            },
            RegionParam: function () {
                let RegionVal = this.$route.query.Region;
                if (RegionVal) {
                    return RegionVal;
                } else {
                    return null;
                }
            },
            StateParam: function () {
                let StateVal = this.$route.query.State;
                if (StateVal) {
                    return StateVal;
                } else {
                    return null;
                }
            },
            PluralChangerUsMe: function () {
                if (this.FamilyInfo.Parent2FirstName) {
                    return "us";
                } else {
                    return "me";
                }
            },
            PluralChangerWeAreIAm: function () {
                if (this.FamilyInfo.Parent2FirstName) {
                    return "We are";
                } else {
                    return "I am";
                }
            },
            PluralChangerWeAreIAmLower: function () {
                if (this.FamilyInfo.Parent2FirstName) {
                    return "we are";
                } else {
                    return "I am";
                }
            },
            PluralChangerWeILower: function () {
                if (this.FamilyInfo.Parent2FirstName) {
                    return "we";
                } else {
                    return "I";
                }
            }
        },
    }
</script>

<style scoped>
    .availability-checkboxes >>> .custom-control.custom-checkbox {
        padding-left: 2rem;
        margin-bottom: 0.25rem;
    }
    .availability-checkboxes >>> .custom-control-label::before,
    .availability-checkboxes >>> .custom-control-label::after {
        left: -1.75rem;
    }
</style>